<template>
  <div
    ref="kt_modal_finalizar_venda"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_finalizar_venda"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header p-3">
          <div class="btn btn-sm btn-active-light-primary" @click="cancelar()">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="d-flex flex-column flex-lg-row">
            <div class="flex-fill flex-column flex-row-fluid mb-10 mb-lg-0 p-2">
              <div class="d-flex">
                <div class="input-group mb-2">
                  <span class="input-group-text">Valor R$</span>
                  <CurrencyInput
                    id="txtValor"
                    class="form-control fs-1 text-danger"
                    placeholder="Valor"
                    style="text-align: right"
                    v-model="this.valor"
                    :options="optionsValor"
                    :class="[
                      'form-control',
                      errosValidacao['valor'] ? 'is-invalid' : '',
                    ]"
                  ></CurrencyInput>
                </div>
              </div>
              <template
                v-for="(item, index) in this.especiesPagamento"
                :key="index"
              >
                <div
                  :id="'especie' + index"
                  class="btn btn-outline btn-outline btn-active-light-primary d-flex align-items-center p-2 mt-2"
                  @click="this.adicionarPagamento(item, this.valor)"
                >
                  <div v-if="item.icone" class="symbol symbol-30px me-5">
                    <div
                      class="symbol-label fs-2 fw-bold bg-light-dark"
                      :style="{
                        'background-image': `url(${
                          this.$utils.getUrl() + item.icone
                        })`,
                      }"
                    ></div>
                  </div>
                  <div v-else class="symbol symbol-30px me-5">
                    <div
                      :class="[
                        'symbol-label fs-3 fw-bold bg-light-secondary text-secondary',
                      ]"
                    >
                      {{
                        item.descricao
                          ? item.descricao.substring(0, 1).toUpperCase()
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="flex-grow-1 me-5">
                    <a class="text-dark fw-bold fs-4">{{
                      item.atalho + " - " + item.descricao
                    }}</a>
                  </div>
                </div>
              </template>
            </div>
            <div class="d-flex flex-column flex-fill p-2">
              <div
                class="d-flex flex-column"
                v-if="
                  this.especiesAdicionadas &&
                  this.especiesAdicionadas !== null &&
                  this.especiesAdicionadas !== undefined &&
                  this.especiesAdicionadas.length > 0
                "
              >
                <template
                  v-for="(item, index) in this.especiesAdicionadas"
                  :key="index"
                >
                  <div
                    :id="'especieAdicionada' + index"
                    class="d-flex align-items-center p-2"
                  >
                    <div class="flex-grow-1 me-5">
                      <a class="text-dark fw-bold fs-4">{{
                        item.especie.descricao
                      }}</a>
                    </div>
                    <div class="d-flex align-items-end">
                      <div class="fw-bold fs-5 text-dark">
                        {{ this.$utils.formatarNumero(item.valor, 2) }}
                      </div>
                    </div>
                    <div class="d-flex align-items-end ms-2">
                      <button
                        class="btn btn-icon btn-active-danger btn-sm"
                        @click="this.removerEspecieAdicionada(index)"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Remover"
                      >
                        <span class="svg-icon svg-icon-5 m-0">
                          <inline-svg
                            src="media/icons/duotune/general/gen027.svg"
                          />
                        </span>
                      </button>
                    </div>
                  </div>
                  <div
                    class="separator separator-dashed my-1"
                    v-if="this.especiesAdicionadas.length - 1 !== index"
                  ></div>
                </template>
              </div>
              <div class="mt-auto">
                <button class="btn btn-light btn-icon-warning fs-6 my-2">
                  F4 - Desconto / Acréscimo
                </button>
                <div
                  class="card card-body align-items-center bg-light-warning p-3 mb-2 d-flex flex-row"
                >
                  <a class="text-dark fw-bold fs-4">Total</a>
                  <a class="text-dark fw-bold fs-2 ms-auto">0,00</a>
                </div>
                <div
                  class="card card-body align-items-center bg-light-info p-3 mb-2 d-flex flex-row"
                >
                  <a class="text-dark fw-bold fs-4">Recebido</a>
                  <a class="text-dark fw-bold fs-2 ms-auto">0,00</a>
                </div>
                <div
                  class="card card-body align-items-center bg-light-primary p-3 d-flex flex-row"
                >
                  <a class="text-dark fw-bold fs-4">Resta</a>
                  <a class="text-dark fw-bold fs-2 ms-auto">0,00</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import CurrencyInput from "@/components/text/CurrencyInput";

export default {
  components: { CurrencyInput },
  emits: ["exibirModalFinalizarVenda", "confirmarModalFinalizarVenda"],
  methods: {
    async confirmar() {
      hideModal(this.$refs.kt_modal_finalizar_venda);
      this.$emit("exibirModalFinalizarVenda", false);
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_finalizar_venda);
      this.$emit("exibirModalFinalizarVenda", false);
    },
    async carregarEspecies() {
      this.especiesPagamento.push({
        descricao: "Dinheiro",
        atalho: "D",
        icone: "",
        codigo: 0,
      });
      this.especiesPagamento.push({
        descricao: "Cartão de Crédito",
        atalho: "C",
        icone: "",
        codigo: 1,
      });
      this.especiesPagamento.push({
        descricao: "Cartão de Débito",
        atalho: "B",
        icone: "",
        codigo: 2,
      });
      this.especiesPagamento.push({
        descricao: "PIX",
        atalho: "P",
        icone: "",
        codigo: 3,
      });
      this.especiesPagamento.push({
        descricao: "Vale Alimentação",
        atalho: "C",
        icone: "",
        codigo: 4,
      });
    },
    async adicionarPagamento(especie, valor) {
      let valorRecebido = 0;
      valorRecebido = !valor ? valor : this.valor;
      if (valorRecebido > 0) {
        this.especiesAdicionadas.push({ especie, valor: valorRecebido });
      }
    },
  },
  async mounted() {
    this.carregarEspecies();
    this.$utils.requestFocus("txtValor");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      especiesPagamento: [],
      especiesAdicionadas: [],
      valor: 0,
      optionsValor: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
